import type { ProfilesDaoSimProfileDetails } from 'types/__generated__/SimInventoryApi';
import type { SingleLegacyPlan } from 'types/legacyDashboard';
import SimProfileFilter from './SimProfileFilter';
import PlanProfileFilter from './PlanProfileFilter';

interface ProfileFilterProps {
  simProfiles?: ProfilesDaoSimProfileDetails[];
  planProfiles?: SingleLegacyPlan['profiles'];
}

const ProfileFilter = (props: ProfileFilterProps) => {
  const { simProfiles, planProfiles } = props;

  if (simProfiles && simProfiles.length > 0) {
    return <SimProfileFilter simProfiles={simProfiles} />;
  }
  if (planProfiles && planProfiles.length > 0) {
    return <PlanProfileFilter planProfiles={planProfiles} />;
  }
  return null;
};

export default ProfileFilter;
